import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#0D0E14",
      paper: "#161B22",
    },
    primary: {
      main: "#FDB940",
      contrastText: "#000",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255,255,255,0.55)",
    },
    divider: "rgba(255,255,255,0.07)",
  },

  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#161B22",
            borderRadius: "10px",
            "& fieldset": { borderColor: "rgba(255,255,255,0.1)" },
            "&:hover fieldset": { borderColor: "rgba(253,185,64,0.4)" },
            "&.Mui-focused fieldset": { borderColor: "#FDB940" },
          },
          "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.45)" },
          "& .MuiInputLabel-root.Mui-focused": { color: "#FDB940" },
          "& .MuiInputBase-input": { color: "#fff" },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#1A1C24",
          borderRadius: "16px",
          border: "1px solid rgba(255,255,255,0.07)",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: { root: { color: "#fff", fontWeight: 700 } },
    },
    MuiDialogContentText: {
      styleOverrides: { root: { color: "rgba(255,255,255,0.75)" } },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: "#FDB940",
          color: "#000",
          fontWeight: 700,
          borderRadius: "10px",
          "&:hover": { background: "#e6a832" },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: "10px" },
        standardWarning: {
          backgroundColor: "rgba(253,185,64,0.1)",
          color: "#FDB940",
          border: "1px solid rgba(253,185,64,0.25)",
          "& .MuiAlert-icon": { color: "#FDB940" },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          "&.Mui-checked": { color: "#FDB940" },
          "&.Mui-checked + .MuiSwitch-track": { backgroundColor: "#FDB940" },
        },
      },
    },
  },

  // Legacy theme keys kept for components that still reference them
  bottomNavStyle: {
    floatingActionStyle: {
      margin: "0px",
      top: "auto",
      right: "20px",
      bottom: "20px",
      left: "auto",
      position: "fixed",
    },
    toolTipStyle: { maxWidth: "620px" },
  },
  mainButton: {
    root: {
      fontFamily: ["helvetica", "serif"].join(","),
      border: 0,
      color: "#000",
      background: "#FDB940",
      "&:hover": { color: "#000", background: "#e6a832" },
    },
  },
  modalStyle: { root: { backdropFilter: "blur(2px)" } },
  purpleButtonStyle: {
    root: {
      fontFamily: ["helvetica", "serif"].join(","),
      border: 0,
      borderRadius: 20,
      background: "#FDB940",
      color: "#000",
      "&:hover": { color: "#000", background: "#e6a832" },
    },
  },
  whiteButtonStyle: {
    root: {
      background: "rgba(255,255,255,0.08)",
      color: "#fff",
      minWidth: "200px",
      maxWidth: "200px",
      border: "1px solid rgba(255,255,255,0.12)",
      borderRadius: "10px",
    },
  },
  offwhiteButtonStyle: {
    root: {
      background: "rgba(253,185,64,0.15)",
      color: "#FDB940",
      minWidth: "200px",
      maxWidth: "200px",
      borderRadius: "10px",
    },
  },
  yellowButtonStyle: {
    root: {
      background: "#FDB940",
      color: "#000",
      borderRadius: "10px",
      fontWeight: 700,
    },
  },
  blackButtonStyle: {
    root: {
      color: "rgba(255,255,255,0.7)",
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
    },
  },
  redButtonStyle: {
    root: {
      fontFamily: ["helvetica", "serif"].join(","),
      border: 0,
      borderRadius: 20,
      background: "#e34e24",
      color: "#fff",
      "&:hover": { color: "#fff", background: "#e34e24" },
    },
  },
});

export default theme;
